
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>


        <div class="row">
          <div class="col-sm-4">
            <div class="form-check mb-3">
              <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

              <label for="acceptTerms" class="form-check-label">US</label><br />
              <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
              <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
              <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
            </div>
          </div>

        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">ICD Info</h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">


            <div class="row">


              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name">ICD Owner's Name <code>*</code></label>
                  <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                         [ngClass]="{'is-valid': f.ICD_Owner_Name.valid, 'is-invalid' : submitted && f.ICD_Owner_Name.valid}"
                         placeholder="Enter  Owner  Name"
                         appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">ICD Company Name <code>*</code></label>
                  <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                         [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                         appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  </div>

                </div>
              </div>


              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_retrain">
                    ICD retraining with?
                  </label>
                  <input type="text" formControlName="ICD_retrain" class="form-control"
                         [ngClass]="{'is-valid': f.ICD_retrain.valid, 'is-invalid' : submitted && !f.ICD_retrain.valid}" placeholder="Enter ICD_retrain "
                         appAiHint="ICD Retrain" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_retrain.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_retrain.errors.required">ICD_retrain   is required</div>
                  </div>

                </div>
              </div>


              <div class="col-sm-4">
                <div class="form-group">
                  <div class="custom-control custom-switch custom-switch-on-success">

                    <label class="col-form-label " for="isInsuranceRequired">Insurance will be continuing ?<code>*</code></label>
                    <select formControlName="isInsuranceRequired" (change)="ChangeIsInsurance()" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.isInsuranceRequired.errors }">
                      <option value="" disabled>Please Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
                <div *ngIf="submitted && f.isInsuranceRequired.errors" class="invalid-feedback">
                  <div *ngIf="f.isInsuranceRequired.errors.required">Insurance will be continuing  is required</div>
                </div>

              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <div class="custom-control custom-switch custom-switch-on-success">

                    <label class="col-form-label " for="Keep_Payroll_Active">Keep Payroll Active ?<code>*</code></label>
                    <select formControlName="Keep_Payroll_Active"   class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Keep_Payroll_Active.errors }">
                      <option value="" disabled>Please Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
                <div *ngIf="submitted && f.Keep_Payroll_Active.errors" class="invalid-feedback">
                  <div *ngIf="f.Keep_Payroll_Active.errors.required">Keep Payroll Active is required</div>
                </div>

              </div>


              <div class="col-md-4">
                <div>
                  <label class="col-form-label  col-md-12" for="login-Last_Date_payroll">Last Payroll Check Date</label>
                  <div class="input-group date" id="reservationdate" data-target-input="nearest">
                    <input type="text" formControlName="Last_Date_payroll" data-target="#reservationdate" autocomplete="off"
                           id="Last_Date_payroll" placeholder="Select Date "
                           class="form-control"
                           appAiHint="Last Payroll Check Date" [aiHintForm]="icdForm"
                           />
                    <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                      <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                    </div>
                    <div *ngIf="submitted && f.Last_Date_payroll.errors" class="invalid-feedback">
                      <div *ngIf="f.Last_Date_payroll.errors.required">Date  is required</div>
                      <div *ngIf="f.Last_Date_payroll.errors.pattern">Date  must be a valid date in the format MM-DD-YYYY</div>
                      <div *ngIf="f.Last_Date_Service.errors.dateNotLessThanToday">Date  cannot be less than today's date.</div>
                    </div>

                  </div>


                </div>


              </div>
              <div class="col-md-4">

                <label class="col-form-label  col-md-12" for="login-Last_Date_Service">Last Day Services Provided </label>
                <div class="input-group date" id="reservationdate" data-target-input="nearest">
                  <input type="text" formControlName="Last_Date_Service" data-target="#reservationdate" autocomplete="off"
                         id="Last_Date_Service" placeholder="Select Date "
                         class="form-control"
                         appAiHint="Last Day Services Provided" [aiHintForm]="icdForm"
                         />
                  <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                    <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                  </div>
                  <div *ngIf="submitted && f.Last_Date_Service.errors" class="invalid-feedback">
                    <div *ngIf="f.Last_Date_Service.errors.required">Date  is required</div>
                    <div *ngIf="f.Last_Date_Service.errors.pattern">Date  must be a valid date in the format MM-DD-YYYY</div>
                    <div *ngIf="f.Last_Date_Service.errors.dateNotLessThanToday">Date  cannot be less than today's date.</div>
                  </div>


                </div>


              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Comments">Comments (please include duration and reason for Inactivity)<code>*</code></label>
                  <textarea formControlName="Comments" class="form-control" [attr.maxlength]="fieldMaxLengths.Comments"
                            [ngClass]="{'is-valid': f.Comments.valid, 'is-invalid' : submitted && !f.Comments.valid}" placeholder="Enter Comments "
                            appAiHint="Comments" [aiHintForm]="icdForm"></textarea>
                  <div class="text-right small mt-1" [ngClass]="{'text-danger': f.Comments.errors?.maxlength,'text-muted': !f.Comments.errors?.maxlength}">

                    {{ icdForm.get('Comments')?.value?.length || 0 }}/{{ fieldMaxLengths.Comments }}

                  </div>
                  <div *ngIf="submitted && f.Comments.errors" class="invalid-feedback">
                    <div *ngIf="f.Comments.errors.required">Comments   is required</div>
                    <div *ngIf="f.Comments.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Comments }} characters allowed
                    </div>
                  </div>

                </div>
              </div>

            </div>
             
              

          </div>





        </div>

        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">Attach Documents</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <!--<div class="col-sm-4">


                <div class="form-group">
                  <label class="col-form-label col-md-12" for="login-Attach_NC_Recommendation">NC Recommendation  <code>*</code></label>
                  <input type="file" formControlName="Attach_NC_Recommendation"
                         (change)="onFileSelected($event, 'Attach_NC_Recommendation')"
                         [ngClass]="{'is-valid': f.Attach_NC_Recommendation.valid, 'is-invalid' : submitted && !f.Attach_NC_Recommendation.valid}"
                         class="form-control" [class.is-invalid]="isInvalid('Attach_NC_Recommendation')" />
                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_NC_Recommendation')">
                    <div *ngIf="icdForm.get('Attach_NC_Recommendation').errors.required">NC Recommendation is required</div>
                    <div *ngIf="icdForm.get('Attach_NC_Recommendation').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_NC_Recommendation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_NC_Recommendation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>-->
                  <!--<a (click)="openFile(fileId, fileName)" href="#" target="_blank">Open File</a>-->

                <!--</div>


              </div>-->

              <br />

              <div class="col-sm-4" *ngIf="isInsuranceRequired == 'false' && selectedCountry == 'Canada'">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Attach_Insurance_Cancellation_Form">Insurance Cancellation Form  <code>*</code></label>
                  <input type="file"  formControlName="Attach_Insurance_Cancellation_Form" class="form-control" [class.is-invalid]="isInvalid('Attach_Insurance_Cancellation_Form')" 

                         [ngClass]="{'is-valid': f.Attach_Insurance_Cancellation_Form.valid, 'is-invalid' : submitted && !f.Attach_Insurance_Cancellation_Form.valid}"
                         (change)="onFileSelected($event, 'Attach_Insurance_Cancellation_Form')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Insurance_Cancellation_Form' }"></ng-container>


                  <div class="invalid-feedback" *ngIf="isInvalid('Attach_Insurance_Cancellation_Form')">
                    <div *ngIf="icdForm.get('Attach_Insurance_Cancellation_Form').errors.required">Attach_Insurance_Cancellation_Form is required</div>
                    <div *ngIf="icdForm.get('Attach_Insurance_Cancellation_Form').errors.maxFilesExceeded">Maximum number of files exceeded.</div>
                    <div *ngIf="icdForm.get('Attach_Insurance_Cancellation_Form').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Attach_Insurance_Cancellation_Form').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>


                </div>
                <div *ngIf="verificationState['Attach_Insurance_Cancellation_Form'] === 'verifying'" class="mt-1 text-muted small">
                  <i class="fas fa-spinner fa-spin"></i> Verifying document...
                </div>
                <div *ngIf="verificationState['Attach_Insurance_Cancellation_Form'] === 'pass'" class="mt-1 text-success small">
                  <i class="fas fa-check-circle"></i> Document verified
                </div>
                <div *ngIf="verificationState['Attach_Insurance_Cancellation_Form'] === 'warn'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification warning
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Insurance_Cancellation_Form']">{{issue}}</li>
                  </ul>
                </div>
                <div *ngIf="verificationState['Attach_Insurance_Cancellation_Form'] === 'warn_disabled_never_shown'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification failed
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Insurance_Cancellation_Form']">{{issue}}</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>


        </div>




      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>
  </form>
</div>


